import React from 'react'
import Image from 'next/legacy/image'

type Props = {
  name?: string
  description?: string
  picked?: boolean
  onClick: () => void
}

const CardPick: React.FC<Props> = ({ name = '', description = '', picked = false, onClick }) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
  <div
    onClick={onClick}
    className={`shadow-sm data-[focus]:ring-indigo-500 group relative relative flex cursor-pointer rounded-lg border border-gray-300 bg-white p-3 focus:outline-none data-[checked]:border-transparent data-[focus]:ring-2 xl:w-1/2 ${
      picked && 'border-primary-700'
    }`}
  >
    <span className="flex w-1/3 flex-1">
      <span className="flex flex-col">
        <span className="block text-sm font-medium text-gray-900">{name}</span>
        <span className="mt-1 flex items-center whitespace-nowrap text-xs text-gray-500">
          {description}
        </span>
      </span>
    </span>
    {picked && (
      <div className="absolute right-2 top-2">
        <Image width={20} height={20} src="/images/icons/pickCheckIcon.svg" alt="check" />
      </div>
    )}
  </div>
)

export default CardPick
